import VisibilitySensor from 'react-visibility-sensor';
import { useEffect, useState } from 'react';
import { Badge, Link, Text, Spinner, LegacyStack, EmptyState, IndexTable } from '@shopify/polaris';
import { getCustomerOrders } from '../../../services/customersService';
import fillZeros from '../../../helpers/fillZeros';
import moment from 'moment';

const ListOrders = (props) => {
  const [orders, setOrders] = useState([]);
  const [metadata, setMetadata] = useState([]);
  const { customerId } = props;

  const callDB = (page = 1, limit = 10) => {
    getCustomerOrders(customerId, { page, limit })
      .then((r) => {
        setMetadata(r.data.metadata);
        setOrders([...orders, ...r.data.data]);
      })
      .catch((e) => {
        throw e;
      });
  };

  useEffect(() => {
    callDB(1);
    // eslint-disable-next-line
  }, []);

  const showSellEndpoint = (id) => `/sells/${id}/?r=${window.btoa('/customers/' + customerId)}`;

  const handleNext = (e) => {
    const page = metadata.page + 1;
    callDB(page);
  };

  const emptyStateMarkup = orders.length === 0 && (
    <EmptyState
      heading="Todavía no hay ningún pedido"
      action={{ content: 'Nuevo pedido' }}
      image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
    ></EmptyState>
  );

  const rowMarkup = orders.map(({ id, createdAt, status, stockQty, distinctProducts }, index) => (
    <IndexTable.Row id={index} key={index} position={index}>
      <IndexTable.Cell>
        <Link dataPrimaryLink url={showSellEndpoint(id)}></Link>
        <Text variant="bodyMd" fontWeight="bold" as="span">
          #{fillZeros(id, 4)}
        </Text>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text variant="bodyMd" as="span">
          {createdAt === null ? '' : moment(createdAt).format('DD/MM/YYYY')}
        </Text>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <>
          {status === 'DRAFT' && (
            <Badge
              status={distinctProducts > 0 ? 'attention' : 'new'}
              progress={distinctProducts > 0 ? 'partiallyComplete' : 'incomplete'}
            >
              {distinctProducts > 0 ? 'Borrador' : 'Nuevo'}
            </Badge>
          )}
          {status === 'INVOICED' && (
            <Badge status="success" progress="complete">
              Facturado
            </Badge>
          )}
        </>
      </IndexTable.Cell>
      <IndexTable.Cell>{stockQty}</IndexTable.Cell>
    </IndexTable.Row>
  ));

  return (
    <>
      {orders.length === 0 ? (
        emptyStateMarkup
      ) : (
        <>
          <IndexTable
            selectable={false}
            emptyState={emptyStateMarkup}
            items={orders}
            itemCount={orders.length}
            headings={[{ title: '' }, { title: 'Fecha' }, { title: 'Estado' }, { title: 'Stock' }]}
          >
            {rowMarkup}
          </IndexTable>
          {orders.length && metadata && metadata.next && (
            <VisibilitySensor onChange={(e) => handleNext(e)}>
              <>
                <LegacyStack spacing="extraTight">
                  <Text variant="headingSm" as="h6">
                    Cargando...
                  </Text>
                  <Spinner size="small" />
                </LegacyStack>
              </>
            </VisibilitySensor>
          )}
        </>
      )}
    </>
  );
};

export default ListOrders;
